import SessionReflectionsModule from './SessionReflectionsModule';
import { useMemberSavedHighlightsHome } from './useMemberSavedHighlightsHome';
import { useMemberSessionPrepHome } from './useMemberSessionPrepHome';
import { useMemberSessionReflectionsHome } from './useMemberSessionReflectionsHome';

const SessionReflections = () => {
  const { isLoading, rows, status } = useMemberSessionReflectionsHome();
  const { prep } = useMemberSessionPrepHome();
  const { totalCount: highlightsTotalCount } = useMemberSavedHighlightsHome({
    sort: 'created_at',
  });

  if (status === 'error' && !prep) {
    return null;
  }

  return (
    <SessionReflectionsModule
      hasReflectionError={status === 'error'}
      highlightsTotalCount={highlightsTotalCount}
      isLoading={isLoading}
      prep={prep}
      rows={rows}
    />
  );
};

export default SessionReflections;
